<template>
  <main class="container">
    <div class="wrapper">
      <page-header class="page-header" title="You're Nearly Done!">
        <template #subtitle>
          Congratulations, you’ve signed up!<br />
          Now you need to invite your housemates so they can sign up too.
        </template>
      </page-header>

      <button
        class="btn btn--big invite-hm8s-btn"
        data-testid="invite-hm8s-btn"
        @click="setShareModalVisible"
      >
        Invite Housemates
      </button>

      <p class="cancel-disclaimer">
        You'll receive an email notification within 3 business days confirming
        your Direct Debit mandate has been set up.
      </p>

      <hr />

      <div class="share-info">
        <h1 class="share-title">Share This With Your Housemates</h1>
        <p>
          If you don’t have your housemates details to hand, you can send them
          this link to sign up.
        </p>
      </div>

      <SocialShare
        class="mb-0"
        share-action="Share Account Join Link"
        :address-line1="firstAddressLine"
        :share-link="joinLink"
        share-subject="Join our UniHomes utilities account at "
        :share-body="shareBody"
        :whats-app-share-body="whatsAppShareBody"
        :email-via-modal="true"
        :inline="true"
        @show-modal="setShareModalVisible"
        @whatsAppShare="trackWhatsAppShare"
        @emailShare="trackEmailShare"
        @copyShareLink="trackCopyLink"
      />
    </div>

    <SignupShareOverlay
      :guid="guid"
      :remaining-housemate-count="remainingHousemateCount"
      @close-modal="setShareModalInvisible"
      v-if="showShareModal"
      @inviteBtnSubmit="trackInviteSubmitBtn"
    />
  </main>
</template>

<script>
import SocialShare from "@/components/SocialShare";
import SignupShareOverlay from "@/components/SignupShareOverlay";
import PageHeader from "@/components/PageHeader";

export default {
  name: "Congratulations",
  data() {
    return {
      guid: "",
      joinLink: "",
      showShareModal: false,
      whatsAppShareBody:
        "Join the UniHomes account I’ve created for us. Just click this link to add your details:\n\n",
      remainingHousemateCount: 0,
      firstName: "",
      firstAddressLine: "",
    };
  },
  computed: {
    isLeadTenant() {
      return this.$store.getters.isLeadTenant;
    },
    shareBody() {
      return `Hey,

I’ve sorted our utility bills account for ${
        this.firstAddressLine
      }! I’ve created an account with UniHomes who will charge us just one Direct Debit for all our utilities, collecting a monthly payment from each of us separately.

Please can you add yourself onto the account using the link below:

${this.joinLink}

Thanks,
${this.firstName}`;
    },
  },
  methods: {
    setShareModalVisible() {
      this.trackGoogleEvent(
        "Click Invite Housemates",
        this.isLeadTenant ? "Create Account" : "Joining Housemate",
        "Invite Housemates",
      );

      this.showShareModal = true;
    },
    setShareModalInvisible() {
      this.showShareModal = false;
    },
    trackWhatsAppShare() {
      this.trackGoogleEvent(
        "Click share via WhatsApp",
        this.isLeadTenant ? "Create Account" : "Joining Housemate",
        "Share price WhatsApp",
      );
    },
    trackEmailShare() {
      this.trackGoogleEvent(
        "Click share via email",
        this.isLeadTenant ? "Create Account" : "Joining Housemate",
        "Share price email",
      );
    },
    trackCopyLink() {
      this.trackGoogleEvent(
        "Click Copy",
        this.isLeadTenant ? "Create Account" : "Joining Housemate",
        "Copy share price link",
      );
    },
    trackInviteSubmitBtn() {
      this.trackGoogleEvent(
        "Send Housemate Invitation",
        this.isLeadTenant ? "Create Account" : "Joining Housemate",
        "Housemate Invited",
      );
    },
  },
  created() {
    this.trackGoogleEvent(
      "Land on Congratulations Page",
      this.isLeadTenant ? "Create Account" : "Joining Housemate",
      this.isLeadTenant
        ? "Lead tenant completion"
        : "Confirm joining housemate completion",
    );

    this.guid = this.$store.state.accountInformation.guid;
    this.joinLink = this.$store.state.accountInformation.joinLink;
    this.remainingHousemateCount = this.$store.state.accountInformation.remainingHousemates;
    this.firstName = this.$store.state.personalDetails.firstname;
    this.firstAddressLine = this.$store.getters.addressLine1 || "";

    // We've finished the signup so reset the store data
    this.$store.dispatch("clearSession");
    // We don't need back button on this page.
    this.$store.commit("HIDE_BACK_BTN");
  },
  components: {
    PageHeader,
    SocialShare,
    SignupShareOverlay,
  },
};
</script>

<style lang="scss" scoped>
.container {
  text-align: center;

  @include media(">=medium") {
    max-width: 65rem;
  }
}

.wrapper {
  @include media(">=medium") {
    background-color: white;
    border-radius: $border-radius-large;
    margin-top: $spacing-large;
    padding: $spacing-medium;
  }

  .page-header {
    margin-bottom: $spacing-medium;

    @include media(">=medium") {
      margin-top: $spacing-small;
    }
  }
}

.invite-hm8s-btn {
  font-size: 24px;
  font-weight: $font-bold;
  margin-bottom: 0;
}

.share-info {
  margin: 0;

  .share-title {
    @extend .page-title;
    margin-bottom: 0.5rem;
  }

  p {
    font-size: $subtitle-font-size;
    color: $grey-dark;
    margin: 0 0 $spacing-xs 0;

    @include media(">=medium") {
      width: $container-button-width;
      margin-left: auto;
      margin-right: auto;
    }
  }
}

.cancel-disclaimer {
  font-size: 1.6rem;
  color: $grey-dark;

  @include media(">=medium") {
    width: $container-button-width;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
